import * as React from 'react';
import { useEffect } from 'react';
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { DateUtil } from "../../fxms/datas/DateUtil";

/* Factory dashboard real-time energy supply chart (Johab) */
export const FxDashChart2ProdJohab = (props) => {
  const { energy, allValues, facList, isDetailView, onDetailView } = props;
  const unitSuffix = energy === "AIR" ? "Nm3/h" : energy === "STEAM" ? "kg/h" : "";

  const makeSeries = () => {
    const series = [];

    if (allValues && facList.length !== 0) {
      const s = {};
      s.name = "\uC804\uCCB4";
      s.type = "line";
      s.data = [];
      s.color = "#7cdfff";
      s.lineWidth = 2.4;
      s.marker = { enabled: false };

      if (allValues.all !== undefined) {
        for (const data of allValues.all) {
          s.data.push([DateUtil.makeDate(data.psDate).getTime(), data.prodInstVal]);
        }
      }
      series.push(s);

      for (const fac of facList) {
        if (fac.facNo === "1000498") {
          continue;
        }
        const facValues = allValues[fac.facNo];
        if (!facValues) continue;

        const facSeries = {};
        facSeries.name = fac.facDescr;
        facSeries.type = "line";
        facSeries.data = [];
        facSeries.lineWidth = 1.3;
        facSeries.marker = { enabled: false };

        for (const data of facValues) {
          facSeries.data.push([DateUtil.makeDate(data.psDate).getTime(), data.prodInstVal]);
        }
        series.push(facSeries);
      }
    }

    return series;
  };

  const getChartData = (title) => {
    return {
      title: {
        text: title,
        align: "center",
      },
      colors: ["#00a0b0", "#24c29f", "#24CBE5", "#0ea829", "#75ce17"],
      tooltip: {
        crosshairs: true,
        shared: true,
        valueSuffix: " ",
        backgroundColor: "rgba(19, 26, 40, 0.96)",
        borderColor: "#4fc3f7",
        borderWidth: 1,
        borderRadius: 8,
        style: {
          color: "#edf4ff",
          fontSize: "12px",
        },
        formatter: function () {
          let tooltip =
            '<span style="font-size: 11px;color:#9eb9e8">' +
            Highcharts.dateFormat("%Y\uB144 %m\uC6D4 %d\uC77C %H\uC2DC %M\uBD84", this.x) +
            "</span><br/>";
          this.points.forEach(function (point) {
            const formattedValue = Math.round(point.y).toLocaleString("ko-KR");
            tooltip +=
              '<span style="color:' +
              point.series.color +
              '">&#9679;</span> ' +
              point.series.name +
              ": <b>" +
              formattedValue +
              "</b> " +
              unitSuffix +
              "<br/>";
          });
          return tooltip;
        },
      },
      plotOptions: {
        series: {
          animation: {
            duration: 400,
          },
          cursor: "pointer",
          linecap: "round",
          point: {
            events: {
              click: (e) => {
                onDetailView(e);
              },
            },
          },
        },
      },
      xAxis: {
        type: "datetime",
        min: (() => {
          const today = new Date();
          return new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0, 0).getTime();
        })(),
        max: (() => {
          const today = new Date();
          return new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 999).getTime();
        })(),
        labels: {
          style: {
            color: "rgba(229,239,255,0.82)",
          },
          formatter: function () {
            return new Date(this.value).toLocaleTimeString("ko-KR", { hour: "numeric", hour12: false });
          },
        },
        tickInterval: 3 * 60 * 60 * 1000,
        lineColor: "rgba(102, 118, 153, 0.55)",
        tickColor: "rgba(102, 118, 153, 0.55)",
      },
      yAxis: {
        title: {
          text: null,
        },
        labels: {
          style: {
            color: "rgba(211, 223, 247, 0.75)",
            fontSize: "11px",
          },
        },
        lineWidth: 1,
        lineColor: "#3e3e3e",
        gridLineColor: "rgba(115, 131, 171, 0.30)",
        gridLineDashStyle: "ShortDot",
      },
      chart: {
        backgroundColor: "#2f3440",
        borderWidth: 0,
        borderRadius: 0,
        borderColor: "#303030",
        plotBackgroundColor: "#2d323d",
        plotBorderWidth: 0,
        plotBorderColor: "#303030",
        events: {
          click: (e) => {
            onDetailView(e);
          },
          render: function () {
            if (this.wheelEventAdded) return;
            this.wheelEventAdded = true;
            this.container.addEventListener("wheel", (event) => {
              event.preventDefault();
              const chart = this;
              const xAxis = chart.xAxis[0];

              const today = new Date();
              const startOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0, 0).getTime();
              const endOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 999).getTime();

              const rect = chart.container.getBoundingClientRect();
              const mouseX = event.clientX - rect.left;
              const xValue = xAxis.toValue(mouseX, true);

              const min = xAxis.min;
              const max = xAxis.max;
              const range = max - min;

              const ratio = (xValue - min) / range;
              const zoomFactor = event.deltaY < 0 ? 0.8 : 1.25;
              const newRange = range * zoomFactor;

              const newMin = xValue - newRange * ratio;
              const newMax = xValue + newRange * (1 - ratio);

              if (newMin <= startOfDay && newMax >= endOfDay) {
                xAxis.setExtremes(startOfDay, endOfDay, true, false);
              } else {
                xAxis.setExtremes(newMin, newMax, true, false);
              }
            });
          },
        },
      },
      credits: {
        enabled: false,
      },
      series: makeSeries(),
      legend: {
        enabled: true,
        align: "center",
        verticalAlign: "bottom",
        layout: "horizontal",
        itemDistance: 12,
        symbolWidth: 18,
        symbolHeight: 8,
        symbolRadius: 2,
        padding: 8,
        margin: 10,
        backgroundColor: "rgba(20, 28, 40, 0.35)",
        borderColor: "rgba(110, 140, 190, 0.35)",
        borderWidth: 1,
        borderRadius: 8,
        itemStyle: {
          color: "rgba(230, 240, 255, 0.92)",
          fontWeight: "600",
          fontSize: "12px",
          textOutline: "none",
        },
        itemHoverStyle: {
          color: "#ffffff",
        },
        itemHiddenStyle: {
          color: "rgba(168, 184, 212, 0.42)",
        },
      },
    };
  };

  useEffect(() => {
    const values = allValues[energy];
    if (values === undefined) {
      return;
    }
  }, [allValues, energy]);

  return (
    <HighchartsReact
      containerProps={{
        style: {
          height: isDetailView ? "450px" : "228px",
          width: "100%",
          borderRadius: "10px",
          overflow: "hidden",
        },
      }}
      highcharts={Highcharts}
      options={getChartData("", "", "", "")}
    />
  );
};
